import * as THREE from 'three';

export class ExplosionEffect {
  readonly group = new THREE.Group();
  readonly light: THREE.PointLight;
  private readonly particles: THREE.Mesh[] = [];
  private timer = 0;
  private readonly duration = 0.7;
  alive = true;

  constructor(position: THREE.Vector3, color: string, scene: THREE.Scene) {
    this.group.position.copy(position);

    // 闪光点光源
    this.light = new THREE.PointLight(color, 8, 15, 2);
    this.light.position.copy(position);
    scene.add(this.light);

    const count = 24;
    for (let i = 0; i < count; i++) {
      const size = 0.1 + Math.random() * 0.4;
      // 混合球体和方块
      const geo = i % 3 === 0
        ? new THREE.SphereGeometry(size, 4, 4)
        : new THREE.BoxGeometry(size, size, size);
      const mat = new THREE.MeshBasicMaterial({
        color: new THREE.Color().setHSL(
          0.07 + Math.random() * 0.1, // 橙-红色调
          0.9,
          0.4 + Math.random() * 0.5,
        ),
        transparent: true,
        opacity: 1,
      });
      const particle = new THREE.Mesh(geo, mat);
      particle.position.set(
        (Math.random() - 0.5) * 2.5,
        Math.random() * 2.5,
        (Math.random() - 0.5) * 2.5,
      );
      particle.userData.velocity = new THREE.Vector3(
        (Math.random() - 0.5) * 8,
        3 + Math.random() * 6,
        (Math.random() - 0.5) * 8,
      );
      this.group.add(particle);
      this.particles.push(particle);
    }

    // 环形冲击波
    const ringGeo = new THREE.TorusGeometry(0.4, 0.08, 8, 16);
    const ringMat = new THREE.MeshBasicMaterial({
      color,
      transparent: true,
      opacity: 1,
    });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.rotation.x = Math.PI / 2;
    ring.userData.isRing = true;
    this.group.add(ring);
    this.particles.push(ring);
  }

  update(delta: number): void {
    this.timer += delta;
    if (this.timer >= this.duration) {
      this.alive = false;
      if (this.light) this.light.intensity = 0;
      return;
    }

    const progress = this.timer / this.duration;
    this.light.intensity = 8 * (1 - progress);

    for (const p of this.particles) {
      if ((p.userData as { isRing?: boolean }).isRing) {
        // 冲击波扩散
        const s = 1 + progress * 3;
        p.scale.setScalar(s);
        (p.material as THREE.MeshBasicMaterial).opacity = 1 - progress;
        continue;
      }

      const vel = p.userData.velocity as THREE.Vector3;
      vel.y -= 12 * delta;
      p.position.addScaledVector(vel, delta);
      (p.material as THREE.MeshBasicMaterial).opacity = 1 - progress;
      p.scale.setScalar(1 - progress * 0.6);
    }
  }

  dispose(): void {
    if (this.light) {
      this.light.dispose();
    }
    for (const p of this.particles) {
      p.geometry.dispose();
      (p.material as THREE.Material).dispose();
    }
  }
}
